import RoleProtectedRoute from '../RoleProtectedRoute';
import DoctorLayout from './DoctorLayout';

const ProtectedDoctorLayout = () => {
  return (
    <RoleProtectedRoute requiredRole="doctor">
      <DoctorLayout />
    </RoleProtectedRoute>
  );
};

export default ProtectedDoctorLayout;
